import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ImportanceMenu from '@src/components/ImportanceMenu';
import './styles.scss';

const SHOW_MORE_LIMIT = 9;
const INITIAL_SHOWN_COUNT = 15;

function orderSkillsBasedOnSelection(tags, activeSkills) {
  return [
    skill => (activeSkills[skill.id] ? 1 : 0),
    skill => (_.intersection(skill.tags, tags).length > 0 ? 1 : 0),
    skill => (skill.popularity > 5 ? 1 : 0),
    skill => _.intersection(skill.tags, tags).length,
    skill => skill.popularity,
  ];
}
const SKILL_ORDERS = ['desc', 'desc', 'desc', 'desc'];

export default class SkillsSection extends PureComponent {
  static propTypes = {
    activeSkills: PropTypes.object.isRequired,
    lastPickedSection: PropTypes.string.isRequired,
    section: PropTypes.object.isRequired,
    selectImportance: PropTypes.func.isRequired,
    selectSkill: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      allShown: false,
      options: props.section.options,
    };
  }

  toggleShowAll = () => {
    this.setState(({ allShown }) => ({ allShown: !allShown }));
  };

  selectSkill = (option, sectionFull) => {
    const { activeSkills, section, selectSkill } = this.props;

    if (sectionFull) {
      if (activeSkills[option.id]) {
        selectSkill(option, section.tag);
      }
    } else {
      selectSkill(option, section.tag);
    }
  };

  selectImportance = (isMandatory, option) => {
    const {
      section: { tag },
      selectImportance,
    } = this.props;
    selectImportance(option, tag, isMandatory);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.lastPickedSection !== this.props.section.tag) {
      const tags = _.transform(
        nextProps.activeSkills,
        (result, value) => {
          result.push(value.tag);
        },
        [],
      );

      this.setState(({ options }) => ({
        options: _.orderBy(options, orderSkillsBasedOnSelection(tags, nextProps.activeSkills), SKILL_ORDERS),
      }));
    }
  }

  hasMandatory = activeSkills => {
    return _.some(activeSkills, 'isMandatory');
  };

  render() {
    const { section, activeSkills } = this.props;
    const { allShown, options } = this.state;

    // only order section if last skill pick did not originate from current section
    const sectionSelectionCount = _.reduce(
      activeSkills,
      (count, skill) => {
        return skill.section === section.tag || skill.tags.includes(section.tag) ? ++count : count;
      },
      0,
    );

    const _options = _(options)
      .reject(section.options, { name: 'Other' })
      .take(!section.collapsible || allShown ? options.length : INITIAL_SHOWN_COUNT)
      .value();

    const canShowMore = section.collapsible && options.length > SHOW_MORE_LIMIT;
    const sectionFull = sectionSelectionCount >= section.limit;

    const hasMandatory = this.hasMandatory(activeSkills);

    return (
      <div className={classnames('grid-selection three skills-section', sectionFull && 'full')}>
        {_options.map(option => {
          const active = activeSkills[option.id];

          return (
            <div
              className={classnames(
                'grid-selection-item',
                active && 'selected',
                (active || {}).isMandatory && 'mandatory',
              )}
              key={option.id}
              onClick={() => this.selectSkill(option, sectionFull)}
            >
              <span>{option.name}</span>
              {active && !hasMandatory && <ImportanceMenu item={option} onSelect={this.selectImportance} />}
            </div>
          );
        })}

        {canShowMore && (
          <span className="skills-show-all" onClick={this.toggleShowAll}>
            {allShown ? 'Show less' : 'Show more'}
          </span>
        )}
      </div>
    );
  }
}
